import React, { useRef, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import BuscaForm from '../../gww-lib/busca-no-form/index';

const useStyles = makeStyles(theme => ({
    formControl: {
        width: "100%",
        marginBottom: 8
    },
    ocultaCampo: {
        display: "none",
    },
}))

export default function FormTrasnporteNfe(props) {
    const classes = useStyles();
    const {
        modeloEntrega,
        modeloEntregaErro,
        modeloEntregaErroTexto,
        setModeloEntrega,
        tipoFrete,
        tipoFreteErro,
        tipoFreteErroTexto,
        setTipoFrete,
        transportadora,
        descricaoTransportadora,
        setDescricaoTransportadora,
        transportadoraErro,
        transportadoraErroTexto,
        setTransportadora,
        veiculo,
        veiculoErro,
        veiculoErroTexto,
        setVeiculo,
        inativo,
    } = props;

    const inputLabel = useRef(null);
    const [labelWidth] = useState(0);

    return (
        <>
            <FormControl variant="outlined" disabled={inativo}
                className={classes.formControl}>

                <InputLabel ref={inputLabel}>
                    Modelo Entrega
                </InputLabel>


                <Select
                    error={modeloEntregaErro}
                    helperText={modeloEntregaErroTexto}
                    value={modeloEntrega}
                    onChange={e => setModeloEntrega(e.target.value)}
                    labelWidth={labelWidth}
                >
                    <MenuItem value={0}>Não se aplica(NF complementar ou de ajuste)</MenuItem>
                    <MenuItem value={1}>Operação presencial</MenuItem>
                    <MenuItem value={2}>Operação não presencial, pela Internet</MenuItem>
                    <MenuItem value={3}>Operação não presencial, Teleatendimento</MenuItem>
                    <MenuItem value={9}>Operação não presencial, outros</MenuItem>
                </Select>

            </FormControl>

            <FormControl variant="outlined" disabled={inativo}
                className={modeloEntrega === 0 || modeloEntrega === 1 ?
                    classes.ocultaCampo
                    : classes.formControl}
            >
                <InputLabel ref={inputLabel}>
                    Tipo de Frete
                </InputLabel>


                <Select
                    error={tipoFreteErro}
                    helperText={tipoFreteErroTexto}
                    value={tipoFrete}
                    onChange={e => setTipoFrete(e.target.value)}
                    labelWidth={labelWidth}
                >
                    <MenuItem value={'C'}>Contratação do Frete por conta do Remetente (CIF)</MenuItem>
                    <MenuItem value={'F'}>Contratação do Frete por conta do Destinatário (FOB)</MenuItem>
                    <MenuItem value={'T'}>Contratação do Frete por conta de Terceiros</MenuItem>
                    <MenuItem value={'R'}>Transporte Próprio por conta do Remetente</MenuItem>
                    <MenuItem value={'D'}>Transporte Próprio por conta do Destinatário</MenuItem>
                    <MenuItem value={'O'}>Sem Ocorrência de Transporte</MenuItem>
                </Select>

            </FormControl>

            {/* eslint-disable-next-line no-mixed-operators */}
            <div className={modeloEntrega === 0 || modeloEntrega === 1 &&
                classes.ocultaCampo}>
                <BuscaForm
                    codigo={transportadora}
                    tabela="PESSOA"
                    label="Transportadora"
                    consultaInstantanea
                    setCodigoPai={(transportadora) => setTransportadora(transportadora)}
                    setDescricao={setDescricaoTransportadora}
                    descricao={descricaoTransportadora}
                    procedureConsulta="WEBSITE_LIST_GPESSOA_L"
                    filtro="CDSPESS"
                    erroTexto={transportadoraErroTexto}
                    erro={transportadoraErro}
                    inativo={inativo}
                />
            </div>


            <TextField
                className={modeloEntrega === 0 || modeloEntrega === 1 ? classes.ocultaCampo : classes.textField}
                label="Placa do Veiculo"
                fullWidth
                error={veiculoErro}
                helperText={veiculoErroTexto}
                variant="outlined"
                value={veiculo}
                onChange={e => setVeiculo(e.target.value)}
                disabled={inativo}
            />
        </>

    )
}